import React from "react";
import { Form, Input, Button, message, Modal } from "antd";
import styled from "styled-components";
import { FormattedMessage, useIntl } from "react-intl";
import CopyToClipboard from "react-copy-to-clipboard";
import { ok } from "assert";

const { confirm } = Modal;

const AppInfoForm = Form.create({
  name: "AppDetailForm",
  onValuesChange: (props, changedValues, allValues) => props.handleChanged()
})(function(props) {
  const Intl = useIntl();

  const { getFieldDecorator, getFieldError } = props.form;
  const { defaultValue, handleResetSecret, customstyle } = props;
  const redirect_uriError = getFieldError("redirect_uri");

  const handleOnCopy = () => {
    message.success(Intl.formatMessage({ id: "message_copied" }));
  };

  const showResetConfirm = () => {
    confirm({
      title: Intl.formatMessage({ id: "reset_title" }),
      content: Intl.formatMessage({ id: "reset_content" }),
      okText: Intl.formatMessage({ id: "button_reset" }),
      okType: "primary",
      cancelText: Intl.formatMessage({ id: "button_cancel" }),
      onOk() {
        return new Promise((resolve, reject) => {
          handleResetSecret() ? resolve() : reject();
        }).catch(() => {});
      },
      mask: false,
      maskClosable: true,
      autoFocusButton: ok
    });
  };
  return (
    <AppInfoFormWrapper layout="horizontal" customstyle={customstyle}>
      <Title>
        <FormattedMessage id="appSetting_title" />
      </Title>
      <Description>
        <FormattedMessage id="appSetting_description" />
      </Description>
      <Form.Item label={<span className="customLabel">Client ID</span>} colon={false}>
        <DisableInput value={defaultValue.client_id} spellCheck={false} />
        <Copy text={defaultValue.client_id} onCopy={handleOnCopy}>
          <button>{Intl.formatMessage({ id: "input_copy" })}</button>
        </Copy>
      </Form.Item>
      <Form.Item
        label={
          <span className="customLabel">
            Client Secret{" "}
            <Button type="link" style={{ padding: "0 8px" }} onClick={showResetConfirm}>
              <FormattedMessage id="appSetting_reset" />
            </Button>
          </span>
        }
        colon={false}
      >
        <DisableInput value={defaultValue.client_secret} spellCheck={false} />
        <Copy text={defaultValue.client_secret} onCopy={handleOnCopy}>
          <button>{Intl.formatMessage({ id: "input_copy" })}</button>
        </Copy>
      </Form.Item>
      <Form.Item
        label={<span className="customLabel">OAuth redirect URL</span>}
        colon={false}
        validateStatus={redirect_uriError ? "error" : ""}
        help={redirect_uriError || ""}
      >
        {getFieldDecorator("redirect_uri", {
          initialValue: defaultValue.redirect_uri[0] || null,
          validateTrigger: "onBlur",
          rules: [
            {
              type: "url",
              message: <FormattedMessage key="info" id="tip_URL" />
            },
            {
              max: 254,
              message: <FormattedMessage key="info" id="tip_redirectURLMax64" />
            }
          ]
        })(<Input />)}
      </Form.Item>
    </AppInfoFormWrapper>
  );
});

export default AppInfoForm;

const AppInfoFormWrapper = styled(Form)`
  ${props => props.customstyle}
`;

const Title = styled.h1`
  font-size: 24px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 24px;
  margin: 0;
`;

const Description = styled.p`
  font-size: 15px;
  color: rgba(0, 0, 0, 0.45);
  line-height: 22px;
  margin: 24px 0;
  font-weight: 500;
`;

const DisableInput = styled(Input)`
  color: #bfbfbf !important;
`;

const Copy = styled(CopyToClipboard)`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  width: 100%;
  height: 32px;
  background: transparent;
  font-size: 14px;
  line-height: 14px;
  text-align: right;
  outline: none;
  color: #bfbfbf;
  transition: all 0.5s cubic-bezier(0.075, 0.82, 0.165, 1);
  &:hover {
    color: rgba(0, 0, 0, 0.65);
  }
`;
